if (!customElements.get('warranty-option')) {
  customElements.define(
    'warranty-option',
    class WarrantyOption extends HTMLElement {
      constructor() {
        super();

        this.checkbox = this.querySelector('.warranty-checkbox');
        this.variantId = "48093215359209";
        this.cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
        this.mainProductId = '8835968663785'; // ID for "ClearUP 2.0 Sinus Pain and Congestion Relief"

        this.initCheckboxState();
        this.checkbox.addEventListener('change', this.onToggleWarranty.bind(this));
        
        // Listen for cart updates to sync warranty quantity
        document.addEventListener('cart:updated', this.syncWarrantyQuantity.bind(this));
      }

      initCheckboxState() {
        fetch(`${routes.cart_url}.json`)
          .then(response => response.json())
          .then(cartData => {
            const mainProductInCart = cartData.items.some(item => item.product_id.toString() === this.mainProductId);
            const warrantyItem = cartData.items.find(item => item.id.toString() === this.variantId);

            if (!mainProductInCart && warrantyItem) {
              // Main product is not in cart, but warranty is. Remove warranty.
              this.checkbox.checked = false;
              this.removeWarrantyFromCart();
            } else {
              this.checkbox.checked = !!warrantyItem;
              
              // If warranty is checked and in cart, make sure quantities match
              if (this.checkbox.checked && warrantyItem) {
                this.syncWarrantyQuantity(cartData);
              }
            }
          })
          .catch(error => {
            console.error('Error checking warranty in cart:', error);
          });
      }

      // Get the total quantity of the main product in cart
      getMainProductQuantity(cartData) {
        if (!cartData) return 0;
        
        const mainProductItems = cartData.items.filter(item => 
          item.product_id.toString() === this.mainProductId
        );
        
        return mainProductItems.reduce((total, item) => total + item.quantity, 0);
      }

      // Sync warranty quantity with main product quantity
      syncWarrantyQuantity(cartData) {
        // If we received an event object, fetch the cart data first
        if (!(cartData && cartData.items)) {
          fetch(`${routes.cart_url}.json`)
            .then(response => response.json())
            .then(data => this.syncWarrantyQuantity(data))
            .catch(error => console.error('Error fetching cart data:', error));
          return;
        }

        const mainProductQty = this.getMainProductQuantity(cartData);
        const warrantyItem = cartData.items.find(item => item.id.toString() === this.variantId);
        
        // If warranty is in cart but quantity doesn't match main product
        if (warrantyItem && warrantyItem.quantity !== mainProductQty && mainProductQty > 0) {
          this.updateWarrantyQuantity(mainProductQty);
        }
      }

      updateWarrantyQuantity(quantity) {
        const config = fetchConfig('javascript');
        config.headers['X-Requested-With'] = 'XMLHttpRequest';
        delete config.headers['Content-Type'];

        const formData = new FormData();
        formData.append('id', this.variantId);
        formData.append('quantity', quantity);

        if (this.cart) {
          formData.append(
            'sections',
            this.cart.getSectionsToRender().map((section) => section.id)
          );
          formData.append('sections_url', window.location.pathname);
        }

        config.body = formData;

        fetch(routes.cart_change_url, config)
          .then(response => response.json())
          .then(data => {
            if (data.status) {
              console.error('Error updating warranty quantity:', data.errors || data.description);
              return;
            }
            if (this.cart) {
              this.cart.renderContents(data);
            }
          })
          .catch(error => {
            console.error('Error updating warranty quantity:', error);
          });
      }

      removeWarrantyFromCart() {
        const config = fetchConfig('javascript');
        config.headers['X-Requested-With'] = 'XMLHttpRequest';
        delete config.headers['Content-Type'];

        const formData = new FormData();
        formData.append('id', this.variantId);
        formData.append('quantity', '0');

        if (this.cart) {
          formData.append(
            'sections',
            this.cart.getSectionsToRender().map((section) => section.id)
          );
          formData.append('sections_url', window.location.pathname);
        }

        config.body = formData;

        fetch(routes.cart_change_url, config)
          .then(response => response.json())
          .then(data => {
            if (data.status) {
              console.error('Error removing warranty:', data.errors || data.description);
              return;
            }
            if (this.cart) {
              this.cart.renderContents(data);
            } else {
              window.location = window.routes.cart_url;
            }
          })
          .catch(error => {
            console.error('Error removing warranty:', error);
          });
      }

      onToggleWarranty(evt) {
        evt.preventDefault();

        const isChecked = this.checkbox.checked;
        
        if (!isChecked) {
          // If unchecking, simply remove the warranty
          this.removeWarrantyFromCart();
          return;
        }
        
        // If checking, get the main product quantity first
        fetch(`${routes.cart_url}.json`)
          .then(response => response.json())
          .then(cartData => {
            const mainProductQty = this.getMainProductQuantity(cartData);
            
            if (mainProductQty === 0) {
              console.error('Cannot add warranty: Main product not in cart');
              this.checkbox.checked = false;
              return;
            }
            
            // Add warranty with the same quantity as main product
            const config = fetchConfig('javascript');
            config.headers['X-Requested-With'] = 'XMLHttpRequest';
            delete config.headers['Content-Type'];

            const formData = new FormData();
            formData.append('id', this.variantId);
            formData.append('quantity', mainProductQty);

            if (this.cart) {
              formData.append(
                'sections',
                this.cart.getSectionsToRender().map((section) => section.id)
              );
              formData.append('sections_url', window.location.pathname);
              this.cart.setActiveElement(document.activeElement);
            }

            config.body = formData;

            fetch(routes.cart_add_url, config)
              .then((response) => response.json())
              .then((response) => {
                if (response.status) {
                  console.error('Error adding warranty:', response.errors || response.description);
                  return;
                }
                if (!this.cart) {
                  window.location = window.routes.cart_url;
                  return;
                }
                this.cart.renderContents(response);
              })
              .catch((e) => console.error(e));
          })
          .catch(error => {
            console.error('Error fetching cart data:', error);
          });
      }
    }
  );
}